import axios from '../api/axios';

export const getProfile = async (userId: number, token: string) => {
  const response = await axios.get("profile", {
    params: {
      user_id: userId,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};